type LocalizationType = {
  language: string;
  annotation: string;
};

export const localizationsListArray: LocalizationType[] = [
  { language: 'Georgian (ka)', annotation: 'ka' },
  { language: 'Georgian (ge)', annotation: 'ge' },
  { language: 'Russian', annotation: 'ru' },
  { language: 'English', annotation: 'en' },
  { language: 'Chinese', annotation: 'zh' },
  { language: 'Danish', annotation: 'da' },
  { language: 'Persian (Farsi)', annotation: 'fa' },
  { language: 'Ukrainian', annotation: 'ua' },
  { language: 'Turkish', annotation: 'tr' },
  { language: 'German', annotation: 'de' },
  { language: 'Armenian', annotation: 'hy' },
  { language: 'Swedish', annotation: 'sv' },
  { language: 'Arabic', annotation: 'ar' },
  { language: 'Spanish', annotation: 'es' },
  { language: 'French', annotation: 'fr' },
  { language: 'Romanian', annotation: 'ro' },
  { language: 'Greek', annotation: 'el' },
  { language: 'Hindi', annotation: 'hi' },
  { language: 'Portuguese', annotation: 'pt' },
  { language: 'Brazilian', annotation: 'br' },
  { language: 'Swahili', annotation: 'sw' },
  { language: 'qwerty', annotation: 'qwerty' },
  { language: 'Thai', annotation: 'th' },
  { language: 'Indonesian', annotation: 'id' },
  { language: 'Vietnamese', annotation: 'vi' },
  { language: 'Korean', annotation: 'ko' },
  { language: 'Hrvatski (Croatian)', annotation: 'hr' },
  { language: 'Íslenska (Icelandic)', annotation: 'is' },
  { language: 'Italiano (Italian)', annotation: 'it' },
  { language: '日本語 (Japanese)', annotation: 'ja' },
  { language: 'Lietuvių (Lithuanian)', annotation: 'lt' },
  { language: 'Magyar (Hungarian)', annotation: 'hu' },
  { language: 'Polski (Polish)', annotation: 'pl' },
  { language: 'Slovenščina (Slovenian)', annotation: 'sl' },
  { language: 'Nederlands (Dutch)', annotation: 'nl' },
  { language: 'Estonian', annotation: 'et' },
  { language: 'Finnish', annotation: 'fi' },
  { language: 'Norwegian', annotation: 'no' },
  { language: 'Slovakian', annotation: 'sk' },
  { language: 'Simplified Chinese', annotation: 'zs' },
];

export const localizationsMap: Record<string, string> = {
  ka: 'Georgian (ka)',
  ge: 'Georgian (ge)',
  ru: 'Russian',
  en: 'English',
  zh: 'Chinese',
  da: 'Danish',
  fa: 'Persian (Farsi)',
  ua: 'Ukrainian',
  tr: 'Turkish',
  de: 'German',
  hy: 'Armenian',
  sv: 'Swedish',
  ar: 'Arabic',
  es: 'Spanish',
  fr: 'French',
  ro: 'Romanian',
  el: 'Greek',
  hi: 'Hindi',
  pt: 'Portuguese',
  br: 'Brazilian',
  sw: 'Swahili',
  qwerty: 'qwerty',
  th: 'Thai',
  id: 'Indonesian',
  vi: 'Vietnamese',
  ko: 'Korean',
  hr: 'Hrvatski (Croatian)',
  is: 'Íslenska (Icelandic)',
  it: 'Italiano (Italian)',
  ja: '日本語 (Japanese)',
  lt: 'Lietuvių (Lithuanian)',
  hu: 'Magyar (Hungarian)',
  pl: 'Polski (Polish)',
  sl: 'Slovenščina (Slovenian)',
  nl: 'Nederlands (Dutch)',
  et: 'Estonian',
  fi: 'Finnish',
  no: 'Norwegian',
  sk: 'Slovakian',
  zs: 'Simplified Chinese',
};
